import React, {useReducer, useState} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import {Helmet} from 'react-helmet-async';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';
import styled from 'styled-components';
import {SIZES} from '@fupa/fupa-uikit';
import {ButtonGroup} from 'app/components/button/ButtonGroup';
import {fetchPlayerStatsAlltime, fetchTeamPlayerStats} from 'app/components/team/playerstats/TeamPlayerStatsActions';
import {
  initialPlayerStatsState,
  PlayerStatsState,
  TeamPlayerStatsReducer,
} from 'app/components/team/playerstats/TeamPlayerStatsReducer';
import PlayerStatsAlltimeGrid from 'app/components/team/playerstats/PlayerStatsAlltimeGrid';
import PlayerStatsSeasonGrid from 'app/components/team/playerstats/PlayerStatsSeasonGrid';

const Container = styled.div`
  padding: 0 ${SIZES['4']} ${SIZES['4']};
`;

const getTitle = (type: string, team: any) => {
  if (type === 'alltime') {
    return 'Alltime Spielerstatistik - ';
  }
  return team?.competition?.season?.name
    ? `Spielerstatistik der Saison ${team.competition.season.name} - `
    : `Spielerstatistik der aktuellen Saison - `;
};

interface TeamPlayerStatsPageProps {
  defaultMetaDesc: string;
  team: any;
}

const TeamPlayerStatsPage = ({defaultMetaDesc, team}: TeamPlayerStatsPageProps) => {
  const {restoredData} = useRestoreData('TeamPlayerStatsPage');
  const {teamSlug, type} = useParams();
  const initialState: PlayerStatsState = restoredData ?? initialPlayerStatsState;
  const [state, dispatch] = useReducer(TeamPlayerStatsReducer, initialState);

  const [activeTable, setActiveTable] = useState(type ?? 'season');

  const loadData = (subpage?: string, reload?: boolean, sortQuery?: string) => {
    const statType = subpage ?? type;
    if (statType === 'alltime') {
      fetchPlayerStatsAlltime(teamSlug, reload, sortQuery)(dispatch, state);
      return;
    }
    fetchTeamPlayerStats(teamSlug)(dispatch, state);
  };
  useFetchData(state, loadData, 'TeamPlayerStatsPage');
  const {players, isFetching, error} = state.season;
  const title = getTitle(type, team);
  const meta = [{name: 'description', content: `${title}${defaultMetaDesc}`}];

  const baseUrl = `/team/${teamSlug}/playerstats`;

  const buttons = [
    {url: `${baseUrl}`, label: 'Saison', value: 'season'},
    {url: `${baseUrl}/alltime`, label: 'Alltime', value: 'alltime'},
  ];

  const handleChange = (value: string) => {
    loadData(value);
    setActiveTable(value);
  };

  return (
    // @ts-ignore
    <ContentAdDesktop top='7.125rem' noContentPadding>
      <Helmet title={title} meta={meta} />
      <ButtonGroup activeValue={activeTable} onChange={handleChange} buttons={buttons} />
      <Container>
        {activeTable === 'season' ? (
          <PlayerStatsSeasonGrid players={players} isLoading={isFetching} error={error} />
        ) : (
          <PlayerStatsAlltimeGrid data={state.alltime} loadData={loadData} dispatch={dispatch} />
        )}
      </Container>
    </ContentAdDesktop>
  );
};

export default TeamPlayerStatsPage;
